<template lang="pug">
  #ReservationIndex.container-width(style="background-color: #F8F8F8")
    .d-flex.align-items-center.justify-content-center.p-3
      b-img(
        fluid,
        :src="defaultLogo",
        alt="logo",
        :onerror="defaultLogo",
      )
    b-img(
      fluid,
      :src="defaultBannerUrl",
      alt="logo",
      :onerror="defaultLogo",
    )
    .d-flex.align-items-center.justify-content-center
      b-img.my-3.px-5(
        fluid,
        :src="defaultButtonUrl",
        style="width: 100%"
        alt="logo",
        :onerror="defaultLogo",
        @click="routeToCreate()"
      )
    .row.no-gutters.mx-2.pb-2
      .col-4.px-1.pb-2
        b-img(
          fluid,
          :src="defaultArea1Url",
          alt="logo",
          :onerror="defaultLogo",
          @click="routeLink(1)"
        )
      .col-4.px-1
        b-img(
          fluid,
          :src="defaultArea2Url",
          alt="logo",
          :onerror="defaultLogo",
          @click="routeLink(2)"
        )
      .col-4.px-1
        b-img(
          fluid,
          :src="defaultArea3Url",
          alt="logo",
          :onerror="defaultLogo",
          @click="routeLink(3)"
        )

</template>

<script>
import { mapState } from 'vuex';
import InfiniteLoading from 'vue-infinite-loading';
import { M_RESERVATION_CREATE } from '@/router/member/reservation';
import defaultLogoUrl from '@/assets/images/other/member_reservation_logo.png';
import defaultBannerUrl from '@/assets/images/other/member_reservation_banner.png';
import defaultArea1Url from '@/assets/images/other/member_reservation_area1.png';
import defaultArea2Url from '@/assets/images/other/member_reservation_area2.png';
import defaultArea3Url from '@/assets/images/other/member_reservation_area3.png';
import defaultButtonUrl from '@/assets/images/other/member_reservation_button.png';
import $ from 'jquery';

export default {
  name: 'ReservationIndex',
  components: {
    InfiniteLoading
  },
  data() {
    return {
      infiniteId: +new Date(),
      defaultLogo: defaultLogoUrl,
      defaultBannerUrl: defaultBannerUrl,
      defaultArea1Url: defaultArea1Url,
      defaultArea2Url: defaultArea2Url,
      defaultArea3Url: defaultArea3Url,
      defaultButtonUrl: defaultButtonUrl
    };
  },
  created() {
    const vm = this;
    vm.$swal.fire({
      title: '請稍候，\n載入中',
      allowOutsideClick: false,
      willOpen: () => {
        this.$swal.showLoading();
      }
    });
    vm.$store.commit('member_reservation/resetHandler');
    vm.$swal.close();
    vm.$store.commit('toggleLoading', false);
  },
  mounted() {
    $('#appHeader').addClass('d-none');
  },
  methods: {
    infiniteHandler($state) {
      const vm = this;
      vm.$store.dispatch('member_reservation/getReservationHandler', {
        current_page: vm.pagination.current_page + 1,
        per_page: vm.pagination.per_page,
        status: 'checked'
      }).then(() => {
        if (vm.pagination.current_page !== vm.pagination.total_page) {
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    routeLink(num) {
      switch (num) {
        case 1:
          if (process.env.VUE_APP_ENV === 'dev' || process.env.VUE_APP_ENV === 'local') {
            window.location = "https://tinyurl-dev.skridea.com/KRFYl7F";
          } else {
            window.location = "https://tinyurl.skridea.com/R0LUZbj";
          }
          break;
        case 2:
          if (process.env.VUE_APP_ENV === 'dev') {
            window.location = "https://tinyurl-dev.skridea.com/izFPqIZ";
          } else {
            window.location = "https://tinyurl.skridea.com/Ya6OKNx";
          }
          break;
        case 3:
          if (process.env.VUE_APP_ENV === 'dev') {
            window.location = "https://tinyurl-dev.skridea.com/mi8FB0p";
          } else {
            window.location = "https://tinyurl.skridea.com/bmQmVFk";
          }
          break;
      }
    },
    routeToCreate() {
      const vm = this;
      vm.$router.push({
        name: M_RESERVATION_CREATE
      });
    },
  },
  computed: {
    ...mapState({
      reservations: (state) => state.member_reservation.reservations,
      pagination: (state) => state.member_reservation.pagination
    })
  }
};
</script>

<style scoped>
  .smaller {
    font-size: 75%;
    font-weight: 600;
  }
</style>
